/** API route map: URLS.Controller.JobPublishSetting */
export const JobPublishSetting = {
      Name: 'JobPublishSetting/',
      GetSetting: 'get-job-publish-setting',
      Patch: 'patch',
};
